<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="dialog-container">
      <h3>Create Cheque</h3>
      <section v-if="!isDone">
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="form-item">
            <span>Recipient</span>
            <v-input
              v-model="form.isrd_nm"
              :disabled="true" />
          </div>
          <div class="form-item">
            <span>Amount</span>
            <el-form-item prop="amount">
              <v-input
                v-model="formData.amount"
                prepend="HK$" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Reason</span>
            <el-form-item prop="type">
              <v-select
                v-model="formData.type"
                :list="typeOptions" />
            </el-form-item>
          </div>

          <div class="flex-sb">
            <div>
              <v-button @click="handlerCancel">Cancel</v-button>
            </div>
            <div>
              <v-button
                type="primary"
                @click="handlerCreate">Create</v-button>
            </div>
          </div>
        </el-form>
      </section>
      <section v-else>
        <p>Your cheque has been created.</p>
        <v-button
          type="primary"
          @click="handlerDone">Done</v-button>
      </section>
    </div>
  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import { createCheque } from '@/api/cheque'
export default {
  name: 'CreateCheque',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({
        isrd_nm: ''
      })
    }
  },
  data() {
    return {
      dialog: false,
      isDone: false,
      formData: {
        type: '',
        amount: ''
      },
    }
  },
  computed: {
    typeOptions() {
      // 1-endorsement 2-cancellation 3-claim 4-refund 5-others
      return [
        {
          id: 1,
          name: 'Endorsement'
        },
        {
          id: 2,
          name: 'Cancellation'
        },
        {
          id: 3,
          name: 'Claim'
        },
        {
          id: 4,
          name: 'Refund'
        },
        {
          id: 5,
          name: 'Others'
        }
      ]
    }
  },
  methods: {
    changeDialog() {
      this.isDone = false
      this.dialog = !this.dialog
    },
    handlerCancel() {
      this.dialog = false
    },
    handlerDone() {
      this.$emit('done')
      this.dialog = false
    },
    handlerCreate() {
      this.$refs['form'].validate(valid => {
        if(valid) {
          this.network().createCheque()
        }
      })
    },
    network() {
      return {
        createCheque: async () => {
          const { data } = await createCheque({
            ...this.formData,
            ...this.form
          })
          this.isDone = true
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .flex-sb {
          padding-top: 5px;
      }
    }
</style>